/** Provider codes rendered fully upper-cased instead of title-cased. */
const UPPERCASE_PROVIDER_CODES = ["nmi", "opay"];

/**
 * Human-readable payment-provider label.
 *
 * `"palmpay" -> "Palmpay"`, `"nmi" -> "NMI"`, `"worldpay" -> "Worldpay"`.
 * Single source of truth shared by the card routing UI (PaymentToggle) and
 * the Apple Pay V2 routing UI so provider casing stays consistent.
 */
export const formatProviderLabel = (code: string): string => {
  if (!code) {
    return "";
  }
  if (UPPERCASE_PROVIDER_CODES.includes(code.toLowerCase())) {
    return code.toUpperCase();
  }
  return code.charAt(0).toUpperCase() + code.slice(1).toLowerCase();
};

export default formatProviderLabel;
